import { APP_ROUTES } from '@zorro/common-utils';
import { StrictExtract } from '@zorro/types';

type ShoppingEntryRouteName = StrictExtract<
  typeof APP_ROUTES,
  'DISCOVERY_SHOPPING_PROFILING' | 'PERSONALIZED_ALLOWANCE'
>;

export const getShoppingEntryRouteName = (
  isDiscoveryShoppingOn: boolean
): ShoppingEntryRouteName =>
  isDiscoveryShoppingOn
    ? 'DISCOVERY_SHOPPING_PROFILING'
    : 'PERSONALIZED_ALLOWANCE';

export const getShoppingEntryPath = (isDiscoveryShoppingOn: boolean) =>
  isDiscoveryShoppingOn
    ? APP_ROUTES.DISCOVERY_SHOPPING_PROFILING()
    : APP_ROUTES.PERSONALIZED_ALLOWANCE();
